import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  keyForRelationship(key, type) {
    if (key === 'itemModifierList') {
      return 'modifier_list_id';
    }
    return this._super(key, type);
  }
});